import React from "react";

function Item({ data = {}, onSelectUser, isSelected, nameKey }) {
  function onClick() {
    if (onSelectUser) onSelectUser(data, !isSelected);
  }

  return (
    <div
      className="users-groups-picker__users-list__item"
      onClick={onClick}
      style={{
        backgroundColor: isSelected ? "var(--primary-color)" : undefined,
        color: isSelected ? "#FFF" : undefined
      }}
    >
      {data?.[nameKey]}
    </div>
  );
}

export default Item;
